import { render, staticRenderFns } from "./note_actions.vue?vue&type=template&id=39c32524&vue3"
import script from "./note_actions.vue?vue&type=script&lang=js&vue3"
export * from "./note_actions.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports